import { ThunkDispatch } from "core-integration/src/store";
import { getBestClassicPrivateLeagues } from "core-integration/src/store/stats/reducers";
import { fetchBestClassicPrivateLeagues } from "core-integration/src/store/stats/thunks";
import Link from "plos/src/components/links/Link";
import { Cell, Column, Table } from "plos/src/components/Table";
import { footnote } from "plos/src/styles/utils.css";
import { useEffect } from "react";
import { Row, TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { StatusPanel } from "../../StatusPanel";
import {
  leagueTeamHeader,
  leagueTeamName,
  leagueTeamPosition,
  leagueTeamTable,
  leagueTeamTableRow,
  nameCell,
  nameCol,
  posCell,
  posCol,
  scoreCell,
  scoreCol,
} from "../leaguesAndTeams.css";

const BestLeagues = () => {
  const dispatch = useDispatch<ThunkDispatch>();
  const leagues = useSelector(getBestClassicPrivateLeagues);

  const { t } = useTranslation("status");

  useEffect(() => {
    dispatch(fetchBestClassicPrivateLeagues());
  }, [dispatch]);

  return (
    <StatusPanel title={t("bestLeagues.title", "Best Leagues")}>
      <Table
        className={leagueTeamTable}
        aria-label={t("bestLeagues.title", "Best Leagues")!}
      >
        <TableHeader className={leagueTeamHeader}>
          <Column isRowHeader className={posCol}>
            {t("positionAbbr", "Pos")}
          </Column>
          <Column className={nameCol}>
            {t("bestLeagues.league", "League")}
          </Column>
          <Column className={scoreCol}>
            {t("bestLeagues.average", "Average*")}
          </Column>
        </TableHeader>
        <TableBody>
          {leagues.slice(0, 5).map((l, i) => (
            <Row className={leagueTeamTableRow} key={l.league}>
              <Cell className={posCell}>
                <span className={leagueTeamPosition}>{i + 1}</span>
              </Cell>
              <Cell className={nameCell}>
                <Link to={`/leagues/${l.league}/standings/c`}>
                  <span className={leagueTeamName}>{l.name}</span>
                </Link>
              </Cell>
              <Cell className={scoreCell}>{l.average_score}</Cell>
            </Row>
          ))}
        </TableBody>
      </Table>
      {!leagues.length && (
        <p>
          {t(
            "bestLeagues.bestLeaguesAvailability",
            "The Best Leagues will appear here when available.",
          )}
        </p>
      )}
      <p className={footnote}>
        {t(
          "bestLeagues.averageScoreTopFive",
          "*Average score of the top 5 teams in the league",
        )}
      </p>
    </StatusPanel>
  );
};

export default BestLeagues;
